export default "__VITE_ASSET__b44d2384__"